module.exports = __webpack_public_path__ + "media/packs/images/@tehnobank/footer-image-pci-dss-aa8642f4beb6580445416490de332877.png";